<template>
    <div :id="this.$route.name">
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline">مدیرت منوها</h4>
                <hr>
            </template>
            <template v-slot:content>
                <h3><i class="px-3"
                        :class="[showAdd ? ['fas', 'fa-times', 'text-danger'] : ['fad', 'fa-plus-circle', 'text-success']]"
                        @click="fasClick()"></i>
                    <button class="btn float-left" @click="back">بازگشت</button>
                </h3>
                <div class="" v-if="showAdd" id="menuForm">
                    <div class="col-lg-12 col-12">
                        <h6 class="d-inline" v-if="!isEdit">افزدون آیتم به منو {{ menuName }}</h6>
                        <h6 class="d-inline" v-if="isEdit">ویراش آیتم {{ menuName }}</h6>
                        <div class="row" :id="$route.name">
                            <div class="col-lg-4 col-12 text-right">
                                <div class="mt-3">
                                    <small id="LblTitle">نام</small>
                                    <input @keypress="$ValidLenght($event, 100)" type="text" v-model="requiedMenu.Name"
                                        class="form-control InputText required" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">مسیر دسترسی (RouteName)</small>
                                    <input @keypress="$ValidLenght($event, 100)" type="text"
                                        v-model="requiedMenu.RouteName" class="form-control InputText required"
                                        dir="ltr" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">آیکون</small>
                                    <input @keypress="$ValidLenght($event, 100)" type="text"
                                        v-model="requiedMenu.MenuIcon" class="form-control InputText" dir="ltr" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">نام کنترلر (ControlName)</small>
                                    <input @keypress="$ValidLenght($event, 100)" type="text"
                                        v-model="requiedMenu.ControlName" class="form-control InputText required"
                                        dir="ltr" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">مسیر کنترلر (ControlPath)</small>
                                    <input @keypress="$ValidLenght($event, 100)" type="text"
                                        v-model="requiedMenu.ControlPath" class="form-control InputText" dir="ltr" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">IndexMenu</small>
                                    <input @keypress="$ValidLenght($event, 10)" type="text"
                                        v-model="requiedMenu.IndexMenu" class="form-control InputText" dir="ltr" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">IsMenu</small>
                                    <select class="form-control required" v-model="requiedMenu.IsMenu">
                                        <option selected value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-4 col-12">
                                <div class="mt-3">
                                    <small id="LbltblCustomerCode">ماژول</small>
                                    <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetTblProductId" :rownumintable="3"
                                        :action="'TblCrmCombo/GetProductCombo'" :method="'Post'" :idinput="'ProductId'" :keyItem="'ProductId'"
                                        :disabled="false" :defaultvalue="requiedMenu.TblProductId" v-if="$store.state.renderComponentCombo"> </SearchableCombo>
                                </div>
                            </div>

                            <div class="col-lg-12 col-12 mt-3 d-flex justify-content-center align-items-center"
                                v-if="!isEdit">
                                <button class=" btn btn-success col-6" @click="addMenu()">
                                    ثبت
                                </button>
                            </div>
                            <div class="col-lg-12 col-12 mt-3 d-flex justify-content-center align-items-center" v-else>
                                <button class=" btn btn-warning col-6" @click="editMenu()">
                                    ویرایش
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <BnpGrid Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true"
                    v-if="$store.state.renderComponentGrid">
                    <template slot="action-slot" slot-scope="props">

                        <a href="javascript:;" class="mr-2 badge" @click="getMenues(props.props.id)">
                            <h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6>
                        </a>
                        <!-- <a href="javascript:;" class="mr-2 badge" @click="addRoute(props.props)">
                            <h6><span class="fad fa-plus  hover-warning"></span></h6>
                        </a> -->
                        <a href="javascript:;" class="mr-2 badge" @click="edit(props.props)">
                            <h6><span class="fa fa-pencil-square-o hover-info"></span></h6>
                        </a>
                        <a href="javascript:;" class="mr-2 badge" @click="remove(props.props)">
                            <h6><span class="fa fa-times hover-danger"></span></h6>
                        </a>
                    </template>
                </BnpGrid>


            </template>
        </Card>
    </div>

</template>


<script>
import Card from "@/components/Card/Card.vue";
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
    components: { Card, BnpGrid, SearchableCombo },

    data() {
        return {
            userId: this.$session.get('UserInfo').tblUserId,
            propsColumn: [
                { name: 'name', label: 'نام', visibility: true },
                { name: 'routeName', label: 'مسیر دسترسی', visibility: true },
                { name: 'controlName', label: 'نام کنترلر', visibility: true },
                { name: 'id', label: 'شناسه', visibility: false },

            ],
            propsRows: [],
            requiedMenu: {
                Id: null,
                ParentId: null,
                Name: null,
                RouteName: null,
                ControlName: null,
                ControlPath: null,
                MenuIcon: null,
                IsMenu: true,
                IndexMenu: null,
                TblProductId: null
            },
            isEdit: false,
            showAdd: false,
            menuName: '',
            showChild: false,
            res: [],
            data: [],
            lastPage: [],
            nums: [],
            DataaxiosDepUser: {
                Action: "MenuManager/GetMenues",
                Method: "Post",
                ArryfildValue: {
                    Id: this.parentId
                }
            },
            parentIdForAppend: null,
        }
    },

    created() {
        this.getAllMenues()
        // this.$PostData(this.DataaxiosDepUser).then((data) => {
        //     this.data = data
        //     this.getMenues(null)
        // }).catch((err) => {
        //     console.error("CATCH", error);
        // })
    },

    methods: {
        getAllMenues() {
            this.DataaxiosDepUser.Action = "MenuManager/GetMenues"
            this.DataaxiosDepUser.Method = "Post"
            this.DataaxiosDepUser.ArryfildValue = {
                Id: 1
            }
            this.$PostData(this.DataaxiosDepUser).then((data) => {
                this.data = data
                this.getMenues(this.parentIdForAppend)
            }).catch((err) => {
                console.error("CATCH", err);
            })
        },
        addRoute(item) {
            this.nullRequierd()
            this.isEdit = false
            this.showAdd = true
            this.parentId = item.id
            this.menuName = item.name
            this.requiedMenu.ParentId = item.id
        },
        GetTblProductId(data){
            if (data.element != null) {
                // console.log("A", data);
                this.requiedMenu.TblProductId = data.id
            }
        },  
        addMenu() {
            if (this.$ValidForm('menuForm')) {
                this.DataaxiosDepUser.Action = "MenuManager"
                this.DataaxiosDepUser.Method = "Post"
                this.DataaxiosDepUser.ArryfildValue = {
                    ParentId: this.requiedMenu.ParentId,
                    Name: this.requiedMenu.Name,
                    RouteName: this.requiedMenu.RouteName,
                    ControlName: this.requiedMenu.ControlName,
                    ControlPath: this.requiedMenu.ControlPath,
                    MenuIcon: this.requiedMenu.MenuIcon,
                    IsMenu: this.requiedMenu.IsMenu,
                    IndexMenu: this.requiedMenu.IndexMenu,
                    TblProductId: this.requiedMenu.TblProductId
                }
                this.$PostData(this.DataaxiosDepUser).then((response) => {

                    this.$mySweetDefaultTost("عملیات موفق", response.meesage, "success", 1000)

                    this.getAllMenues()
                    // this.data.push(response)
                    // this.propsRows.push(response)

                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })

                    // if (response.parentId == null) {
                    //     this.res.push(response)
                    //     this.propsRows = this.res
                    //     this.$store.state.renderComponentGrid = false;
                    //     this.$nextTick(() => {
                    //         this.$store.state.renderComponentGrid = true
                    //     })
                    // }

                    this.nullRequierd()
                }).catch((error) => {
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                    console.error("CATCH", error);
                })

            }

        },

        back() {
            let lastElement = this.nums.slice(-2);
            if (lastElement[1] != null) {
                this.nums.pop()
            }
            this.propsRows = []
            var n = 0
            for (var i = 0; i < this.data.length; i++) {
                if (this.data[i].parentId == lastElement[0]) {
                    this.propsRows[n] = this.data[i]
                    n++
                }
            }
            this.parentIdForAppend = lastElement[0]

            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
            })
            this.showAdd = false
            this.nullRequierd()
            this.isEdit = false
            this.menuName = ''
        },

        getMenues(id) {
            this.nums.push(id)
            this.propsRows = []
            var n = 0
            for (var i = 0; i < this.data.length; i++) {
                if (this.data[i].parentId == id) {
                    this.propsRows[n] = this.data[i]
                    n++
                }
            }
            this.parentIdForAppend = id
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
            })
            this.showAdd = false
            this.nullRequierd()
            this.isEdit = false
            this.menuName = ''

        },

        edit(item) {
            this.menuName = item.name
            this.showAdd = true
            this.isEdit = true
            this.requiedMenu.Id = item.id
            this.requiedMenu.Name = item.name
            this.requiedMenu.RouteName = item.routeName
            this.requiedMenu.ControlName = item.controlName
            this.requiedMenu.ControlPath = item.controlPath
            this.requiedMenu.MenuIcon = item.menuIcon
            this.requiedMenu.ParentId = item.parentId
            this.requiedMenu.IndexMenu = item.indexMenu
            this.requiedMenu.IsMenu = item.isMenu
            this.requiedMenu.TblProductId = item.tblProductId

            this.$store.state.renderComponentCombo = false
            this.$nextTick(() => {
                this.$store.state.renderComponentCombo = true
            })

        },
        editMenu() {
            if (this.$ValidForm(this.$route.name)) {
                this.DataaxiosDepUser = {
                    Action: "MenuManager",
                    Method: "Put",
                    ArryfildValue: this.requiedMenu
                }
                this.$PostData(this.DataaxiosDepUser).then((response) => {
                    this.$mySweetDefaultTost("عملیات موفق", response.meesage, "success", 1000)
                    this.showAdd = false
                    // var record = this.propsRows.find(element => element.id == this.requiedMenu.Id)
                    // record.name = this.requiedMenu.Name
                    // record.routeName = this.requiedMenu.RouteName
                    // record.controlName = this.requiedMenu.ControlName
                    // record.controlPath = this.requiedMenu.ControlPath
                    // record.menuIcon = this.requiedMenu.MenuIcon
                    // record.isMenu = this.requiedMenu.IsMenu
                    // record.indexMenu = this.requiedMenu.IndexMenu
                    this.getAllMenues()

                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })

                    this.nullRequierd()
                }).catch((error) => {
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                    console.error("CATCH", error);
                })
            }
        },

        fasClick() {
            if (this.showAdd == false) {
                this.nullRequierd()
            }
            this.showAdd = !this.showAdd
            this.requiedMenu.ParentId = this.parentIdForAppend
            this.menuName = ''
            this.isEdit = false
        },

        nullRequierd() {
            this.requiedMenu.Id = null
            this.requiedMenu.Name = null
            this.requiedMenu.RouteName = null
            this.requiedMenu.ControlName = null
            this.requiedMenu.ControlPath = null
            this.requiedMenu.MenuIcon = null
            this.requiedMenu.IsMenu = true
            this.requiedMenu.IndexMenu = null
            this.requiedMenu.TblProductId = null
        },

        remove(item) {
            const swalWithBootstrapButtons = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success mx-1',
                    cancelButton: 'btn btn-danger'
                },
                buttonsStyling: false
            })
            swalWithBootstrapButtons.fire({
                title: 'اطمینان دارید؟',
                text: 'از حذف ' + item.name + '؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'بله، حذف شود',
                cancelButtonText: 'لغو',
                reverseButtons: true
            }).then((result) => {

                if (result.isConfirmed) {
                    this.DataaxiosDepUser = {
                        Action: "MenuManager",
                        Method: "Delete",
                        ArryfildValue: {
                            Id: item.id
                        }
                    }
                    this.$PostData(this.DataaxiosDepUser).then((response) => {

                        if (response.isSuccess == true) {
                            // const index = this.data.indexOf(item)
                            // const indexRes = this.propsRows.indexOf(item)

                            // this.data.splice(index, 1);
                            // this.propsRows.splice(indexRes, 1);
                            this.getAllMenues()
                            this.$store.state.renderComponentGrid = false;
                            this.$nextTick(() => {
                                this.$store.state.renderComponentGrid = true
                            })

                            this.$toasted.success("حذف با موفقیت صورت گرفت", {
                            action: {
                                text: "بستن",
                                onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                                },
                            },
                            });
                        }
                        else {
                            swalWithBootstrapButtons.fire(
                                '',
                                response.message,
                                'error'
                            )
                        }


                    }).catch((error) => {
                        console.error("CATCH", error);
                        swalWithBootstrapButtons.fire(
                            '',
                            'عملیات با خطا مواجه شد',
                            'error'
                        )
                    })
                }
            })
        }

    }
}


</script>

<style scoped>
button.btn {
    color: var(--sidebar-color-item);
}
</style>